import React, { useEffect, useRef, useState } from "react";
import "../../../StyleSheet/MainComponent/Role/RoleCreate.scss";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getStateCreateActions,
  setStateetrieveAction,
  setStateEditActions,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
const StateCreateForm = (props) => {
  const State = useSelector((state) => state);
  const { setShow, show, currentPage, EditId , search,search_field } = props;
 const inputRef =useRef();
  const initialState = {
    State: "",
    description: "",
    pre_area: "",
  };

  useEffect(() => {
    if (EditId != undefined && EditId != "") {
      const payload = {
        EditId: EditId,
      };
      dispatch(setStateetrieveAction(payload));
      console.log(State.StateRetrieve.StateRetrieve, "state");
    }
  }, []);

  const [datas, setDatas] = useState(initialState);
  const [StateError, setStateError] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const [preAreaErr, setPreareaErr] = useState("");
  const handleClose = () => {
    setShow(false);
  };
  const HandleChanges = (e) => {
    if (e.target.name == "pre_area") {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value.slice(0, 4),
        };
      });
    } else {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value,
        };
      });
    }
  };

  useEffect(() => {
    if (
      EditId != undefined &&
      EditId != "" &&
      State.StateRetrieve.StateRetrieve.id
    ) {
      setDatas({
        ...datas,
        State: State.StateRetrieve.StateRetrieve.state_name,
        pre_area: State.StateRetrieve.StateRetrieve.pre_area,
        description: State.StateRetrieve.StateRetrieve.description,
      });
    }
  }, [State.StateRetrieve.StateRetrieve]);
 const [forEdit , setforEdit] = useState(false)
   useEffect(()=>{
    if( State.StateRetrieve.StateRetrieve != undefined && EditId != undefined && datas.State ==  State.StateRetrieve.StateRetrieve.state_name &&
      datas.pre_area == State.StateRetrieve.StateRetrieve.pre_area &&      datas.description === State.StateRetrieve.StateRetrieve.description){
        setforEdit(true)
      }
   },[State.StateRetrieve.StateRetrieve])
  const dispatch = useDispatch();

  const HandleSubmit = () => {
    // console.log(datas);

    if (
      EditId == undefined ||
      EditId == "" ||
      !State.StateRetrieve.StateRetrieve.id
    ) {
      var a = 0;
      if (datas.State == "") {
        a = 1;
        setStateError("*State is Required");
      }
      if (datas.description == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }
      if (datas.pre_area == "") {
        a = 1;
        setPreareaErr("*Pre area is Required");
      }

      if (datas.State !== "" && datas.description !== "") {
        // console.log(datas ,"inner");
        const payload = {
          datas: datas,
          currentPage: currentPage,
          search:search_field
        };

        dispatch(getStateCreateActions(payload, props.setShow()));
      }
    }
  };
  const HandleSubmits = (e) => {
    e.preventDefault();
  };
  const HandleEdits = () => {
    if (
      EditId != undefined &&
      EditId != "" &&
      State.StateRetrieve.StateRetrieve.id
    ) {
      var a = 0;
      if (datas.State == "") {
        a = 1;
        setStateError("*State is Required");
      }
      if (datas.description == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }
      if (datas.pre_area == "") {
        a = 1;
        setPreareaErr("*Pre area is Required");
      }
      if (datas.State !== "" && datas.description !== "") {
        const payload = {
          datas: datas,
          currentPage: currentPage,
          EditId: EditId,
          search:search_field
        };

        dispatch(setStateEditActions(payload, props.setShow()));
      }
    }
  };

  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === "wheel")) {
      event.preventDefault();
    }
  
    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (["e", "E", "+", "-", "."].includes(event.key) || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData('text');
    
    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, '');
    
    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();
    
      event.target.value = filtered;
      HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
    
  };
 
  const preventwheel = (event) => {
    if (event.target&& event.target.className == "form-control"|| event.target.class =="form-control") {
    event.preventDefault();
    }
  }


 
  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {

      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (event.target&& event.target.className == "form-control"|| event.target.class =="form-control") {
        event.preventDefault();
      }
    };
    if (inputElement) {

      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);


  
  

  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups">
            <div className="asds">
              <div class="ModalHeader">
                {EditId == undefined || EditId == "" ? (
                  <span className="UserCreate">State  </span>
                ) : (
                  <span> State  </span>
                )}

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>

              <form class="row g-3 form-fields-wrapper" onClick={HandleSubmits}>
                <div class="col-12 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    State Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={datas.State}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setStateError("");
                    }}
                    required
                    name="State"
                    style={{
                      padding: "15px",
                      // borderRadius: "12px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{StateError}</p>
                </div>

                <div class="col-12 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Pre Area
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    value={datas.pre_area}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setPreareaErr("");
                    }}
                    onKeyDown={(evt) => {
                      preventZoom(evt)

                     }}
                     onPaste={(evt) => handlePaste(evt)} // Handle pasting
                     onWheel={(evt) => preventwheel(evt)} // Prevent zooming with the mouse wheel

                     ref={inputRef}
          required
                    name="pre_area"
                    style={{
                      padding: "15px",
                      // borderRadius: "12px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{preAreaErr}</p>
                </div>

                <div class="col-12 field-div">
                  <label
                    for="validationCustom02"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Description
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    autoComplete="off"
                    value={datas.description}
                    onChange={(e) => {
                      HandleChanges(e);
                      setDescriptionError("");
                    }}
                    name="description"
                    required
                    style={{
                      padding: "15px",
                      // borderRadius: "12px",
                    }}
                  ></textarea>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {DescriptionError}
                  </p>
                </div>
              </form>

              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "space-between",
                  alignItems: "center",
                   marginTop:"30px"
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);
 
                    HandleEdits(e);
                  }}
                   disabled={EditId != undefined && forEdit ? true : false}

                >
                  Submit
                </button>

                <button class="btn CancelBtn" onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StateCreateForm;
